import { AlertNotificationModel } from "../models/alertNotification.model";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root',
})
export class TriggerService {
  // Endpoints
  private readonly triggerBaseEndPoint: string = environment.managementApi + '/Trigger/alertTest/{alertId}?isTest=true';

  constructor(private http: HttpClient) { }

  /**
   * Send the email and sms alert notification
   * @param  {number} alertId - The Alert Id
   * @returns {Promise<AlertNotificationModel>} - Return a AlertNotification response
   */
  async alertTest(alertId: number): Promise<AlertNotificationModel> {
    return new Promise((resolve, reject) => {
      const url = this.triggerBaseEndPoint.replace('{alertId}', alertId.toString());

      this.http
        .get<AlertNotificationModel>(url)
        .subscribe({
          next: (rtnval) => resolve(rtnval),
          error: (err) => reject(err)
        });
    });
  }

}
